<template>
  <div class="login-container">
    <!-- loading 遮罩层 -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-box">
        <div class="spinner"></div>
        <p>登录中...</p>
      </div>
    </div>

    <div class="login-card">
      <h2>岡本代理登录</h2>
      <input v-model="account" type="text" placeholder="账号" />
      <input v-model="password" type="password" placeholder="密码" />
      <button @click="login">登录</button>
      <!-- 错误提示 -->
      <Toast v-if="toastMessage" :message="toastMessage" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import Toast from './Toast.vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const account = ref('')
const password = ref('')
const toastMessage = ref('')
const loading = ref(false)

const login = async () => {
  if (!account.value || !password.value) {
    toastMessage.value = '请输入账号和密码'
    setTimeout(() => (toastMessage.value = ''), 2000)
    return
  }

  loading.value = true
  try {
    const response = await axios.post(
      `api/agent/login?username=${account.value}&password=${password.value}`
    )

    if (response.data.code === '200') {
      localStorage.setItem('username', account.value)
      localStorage.setItem('password', password.value)
      router.push('/receiver')
    } else {
      toastMessage.value = response.data.msg || '用户名或密码错误'
      setTimeout(() => (toastMessage.value = ''), 2000)
    }
  } catch (error) {
    console.error('请求失败:', error)
    toastMessage.value = '服务器连接失败'
    setTimeout(() => (toastMessage.value = ''), 2000)
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(145deg, #f0f0f0, #dcdcdc);
}

.login-card {
  width: 100%;
  max-width: 320px;
  background: white;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  text-align: center;
}

input {
  display: block;
  width: 100%;
  margin: 12px 0;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

button {
  width: 107%;
  padding: 10px;
  border: none;
  background: #3b82f6;
  color: white;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
}

button:hover {
  background: #2563eb;
}

.error {
  margin-top: 12px;
  color: red;
  font-size: 14px;
}

/* loading 遮罩层样式 */
.loading-overlay {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-box {
  background: white;
  padding: 30px 40px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  text-align: center;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #409eff;
  border-top-color: transparent;
  border-radius: 50%;
  margin: 0 auto 16px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
